import { Flex, Layout } from "antd";
import { useMemo } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import NudgeLogo from "../components/NudgeLogo";
import styles from "./layout.module.scss";

const { Header, Content } = Layout;

/** `minimal` drops the sign-up prompt, for pages a customer reaches with their own link. */
const UnprotectedHeaderLayout = ({ minimal = false }: { minimal?: boolean }) => {
  const component = "layout";
  const location = useLocation();
  const navigate = useNavigate();
  const signupModal = () => {
    navigate("/register");
  };
  const headerTextClass = useMemo(
    () => `${styles[`${component}__header-text`]} ${styles[`${component}__header-text-demo`]}`,
    [component],
  );
  return (
    <Layout className={`${styles[`${component}__container`]}`}>
      <Header className={`${styles[`${component}__header`]}`}>
        <NudgeLogo showDomain={false} />
        {!minimal && (
          <Flex vertical>
            <div className={headerTextClass}>{"Welcome to Nudge!"}</div>
            <div className={headerTextClass}>
              <span
                style={{
                  color: "#3B82F6",
                  fontWeight: "bold" as const,
                  cursor: "pointer" as const,
                  marginLeft: 5,
                }}
                onClick={signupModal}
              >
                Signup and try for free
              </span>
            </div>
          </Flex>
        )}
      </Header>
      <Content className={`${styles[`${component}__content`]}`}>
        <Outlet />
      </Content>
    </Layout>
  );
};

export default UnprotectedHeaderLayout;
